import { FeedbackPayload, FeedbackTopic } from './contact-us.type';

export const submitFeedback = async (data: FeedbackPayload) => {
  return await apiClient().post('/ContactUs', data);
};

export const getFeedbackTopics = async () => {
  return await apiClient().get<FeedbackTopic[]>('/ContactUs');
};
